import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { format } from 'date-fns';
import { AddButtonWrapper, HeaderWrapper, TopHeader } from '../Permitting/Documents/Documents';
import SearchInput from '../../../Components/TableWithFilters/SearchInput';
import Table from '../../clientModule/components/Common/Table/Table';
import { headers } from './NotesTableData';
import { RootState } from '../../../redux/root';
import { ModalDefaultDraggable } from '../../../molecules';
import AddNotePopup from './AddNotePopup';
import { useDeleteWikiNoteMutation, useGetWikiNotesQuery } from '../../../redux/rtkQuery/apiWikiNoteSlice';
import { dispatch } from '../../../redux/store';
import { setWikiNote } from '../../../redux/slices/wikiSlice';
import PaginationMobile from '../../../pages/Responsive/PaginationMobile';
import { updatePagination } from '../../clientModule/utils';
import { setPageCount, setPageSize, setRowsCount } from '../../../redux/slices/paginationSlice';

const WikiNotes = () => {
  // @ts-ignore
  const { wikiId } = useParams();
  const filters = useSelector((s: RootState) => s.filters.filters);
  const [filteredRows, _setFilteredRows] = useState<any[]>([]);
  const [showAddNote, setShowAddNote] = useState<boolean>(false);
  const [params, setParams] = useState<any>();
  const { data } = useGetWikiNotesQuery(params, { skip: params === undefined });
  const [deleteWikiNote] = useDeleteWikiNoteMutation();
  const { pageSize, pageIndex } = useSelector((state: RootState) => state.pagination);

  const setFilteredRows = rows => {
    const _rows = getVisualRecords(rows);
    _setFilteredRows(_rows);
  };

  useEffect(() => {
    dispatch(setPageSize(10));
    callSetParams();
  }, []);
  useEffect(() => {
    callSetParams();
  }, [pageIndex, pageSize, filteredRows, setPageCount]);

  useEffect(() => {
    if (filters && data && data.results) {
      dispatch(setRowsCount(data.count));
      const filter = filters.find(f => f.filterName === 'noteSearch');
      if (filter) {
        const { filterValue } = filter;
        const _rows = getVisualRecords(data.results).reduce((rowsArr, item) => {
          if (
            item.topicTitle.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 ||
            item.categoryTitle.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 ||
            item.note.toLowerCase().indexOf(filterValue.toLowerCase()) > -1 ||
            item.modifiedBy.toLowerCase().indexOf(filterValue.toLowerCase()) > -1
          ) {
            rowsArr.push(item);
          }
          return rowsArr;
        }, []);
        setFilteredRows(_rows);
      } else if (data.results) {
          setFilteredRows(data.results);
        }
    }
  }, [filters, data]);

  const callSetParams = () => {
    const _params = {
      limit: pageSize,
      offset: pageIndex * pageSize,
      jurisdiction_id: wikiId,
    };
    setParams(_params);
  };
  const getVisualRecords = rows => {
    const _rows = rows.map(r => {
      const timestamp = format(new Date(r.updatedAt), 'MM/dd/yyyy h:mm a');
      return {
        ...r,
        note: r.note.replace(/\r\n/g, '<br/>'),
        modifiedBy: `${r.modifierFirstName} ${r.modifierLastName} ${timestamp}`,
      };
    });
    return _rows;
  };

  const onEdit = item => {
    dispatch(
      setWikiNote({
        ...item,
        isEditing: true,
      }),
    );
    setShowAddNote(true);
  };
  const onDelete = async item => {
    await deleteWikiNote({ id: item.id });
  };
  return (
    <Wrapper>
      <HeaderWrapper>
        <TopHeader>Notes</TopHeader>
        <RightSide>
          <SearchWrapper>
            <SearchLabel>Search</SearchLabel>
            <SearchInput name="noteSearch" />
          </SearchWrapper>
          <AddButtonWrapper active>
            <Button color="primary" variant="contained" onClick={e => setShowAddNote(true)}>
              Add Note
            </Button>
          </AddButtonWrapper>
        </RightSide>
      </HeaderWrapper>
      <PaginationWrapper>
        <TableWrapper1>
          <Table
            collection={filteredRows}
            headers={headers}
            filterMeta={[]}
            gridTemplateCols="133px 133px 1fr 300px 80px"
            onEdit={onEdit}
            onDelete={onDelete}
            showFilters={false}
          />
        </TableWrapper1>
        <Pagination>
          <PaginationMobile showEverywhere />
        </Pagination>
      </PaginationWrapper>

      {showAddNote && (
        <ModalDefaultDraggable title="Add Note" onClose={() => setShowAddNote(false)}>
          <AddNotePopup setShowAddNote={setShowAddNote} />
        </ModalDefaultDraggable>
      )}
    </Wrapper>
  );
};

export default WikiNotes;

const Wrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

const PaginationWrapper = styled.div`
  height: 300px;
`;

const Pagination = styled.div`
  width: 100%;
  height: 50px;
  padding-right: 7px;
`;

const TableWrapper1 = styled.div`
  max-height: 76vh;
`;

const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

const SearchWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 10px;
`;

const SearchLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--neutral-600);
`;
